<template>
  <v-bottom-navigation
    dark
    :value="value"
    color="white"
    grow
    fixed
    class="ios-footer fotter-tab-color"
  >
    <v-btn
      v-if="userType === 'student'"
      to="/student-dashboard"
      data-v-tour="Home"
    >
      <span>Home</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn
      :to="userType === 'student' ? '/student-bookings' : '/dashboard'"
      data-v-tour="Bookings"
    >
      <span>Bookings</span>
      <v-icon>mdi-calendar</v-icon>
    </v-btn>

    <v-btn to="/chat" data-v-tour="Messages">
      <span>Message</span>
      <v-icon>mdi-chat</v-icon>
    </v-btn>

    <v-btn
      :to="userType === 'student' ? '/student-notifications' : '/notifications'"
      data-v-tour="Notifications"
    >
      <span>Notification</span>
      <v-badge
        v-if="false && notifications"
        color="green"
        :content="notifications"
        overlap
      >
        <v-icon>mdi-bell</v-icon>
      </v-badge>
      <v-icon v-else>mdi-bell</v-icon>
    </v-btn>

    <v-app-bar-nav-icon
      @click="toggleDrawer(!drawer)"
      class="grey--text"
      data-v-tour="Drawer"
    />
  </v-bottom-navigation>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    userType: localStorage.getItem('userType')
  }),
  methods: mapActions(['toggleDrawer', 'toggleDashboardView']),

  computed: {
    value () {
      const path = this.$route?.path || ''
      if (this.userType === 'student') {
        if (path === '/student-dashboard') return 0
        if (path === '/student-bookings') return 1
        if (path.startsWith('/chat')) return 2
        if (path === '/student-notifications') return 3
        return -1
      }
      if (this.userType === 'instructor') {
        if (path === '/dashboard') return 0
        if (path.startsWith('/chat')) return 1
        if (path === '/notifications') return 2
        return -1
      }
      return -1
    },
    notifications () {
      return (
        this.instructorAppointments &&
        this.instructorAppointments.filter(
          (appointment) => appointment.get('status') === 'Pending'
        ).length
      )
    },
    ...mapGetters(['user', 'drawer', 'instructorAppointments'])
  },
  created () {
    // TODO: need to implement porperly
    if (!this.$vuetify.breakpoint.lgAndUp) {
      this.toggleDrawer(false)
      document.body.addEventListener('click', (e) => {
        if (e.target.classList.contains('v-overlay__scrim')) {
          this.toggleDrawer(false)
        }
      })
    }
  }
}
</script>
